import React from 'react';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {withSystem, Plugins, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TBoolean, TText, TRecord} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {
  getBoolean,
  getInPojo,
  getStringOrElse,
} from '@packages/utilities/data-utils';

const CommerceCheckoutAdditionalCheckbox = Atom.createRender(
  ({attributes, classes, data, generateAttributes}) => {
    const name = getStringOrElse(getInPojo(data, ['name']), '');
    const required = getBoolean(getInPojo(data, ['required'])) || false;
    const startChecked = getBoolean(getInPojo(data, ['startChecked'])) || false;

    return (
      <input
        {...generateAttributes(attributes, classes)}
        name={name}
        type="checkbox"
        checked={startChecked}
        required={required}
        onChange={() => {}}
      />
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Checkbox',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Checkbox')),
  },
  showEmpty: false,
  constraints: {
    pinToParent: true,
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginRight: px(8),
        },
      },
    },
  },
  render: CommerceCheckoutAdditionalCheckbox,
  fields: {
    attr: TRecord({
      'aria-labelledby': withSystem({private: true}, TText),
    }),
    name: withSystem({label: 'Name', defaultValue: 'Gift'}, TText),
    startChecked: withSystem(
      {label: 'Start checked', defaultValue: false},
      TBoolean
    ),
    required: withSystem({label: 'Required', defaultValue: false}, TBoolean),
  },
});

export default config;
